import { render, staticRenderFns } from "./BlogSidebarPost.vue?vue&type=template&id=916dd00e&"
import script from "./BlogSidebarPost.vue?vue&type=script&lang=js&"
export * from "./BlogSidebarPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports